
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import ModalTitle from "@/lib/model/exam/modal-title";
import ModalHeader from "@/components/modal-header.vue";

@Component({
  components: {
    ModalHeader
  }
})
export default class CandidateExport extends Vue {
  @Prop() private isShowDownloadModal!: boolean;

  modalTitle: ModalTitle = new ModalTitle();

  @Emit("on-download-close")
  downloadClose() {
    return;
  }

  mounted() {
    this.modalTitle.title = "导出任务创建成功";
    this.modalTitle.hasDesc = false;
  }

  toDownloadLog() {
    this.downloadClose();
    const exportListUrl = `/export-component/list?companyId=${Auth.companyId}`;
    window.open(exportListUrl);
  }
}
